import { AxiosResponse } from 'axios'
import { Dispatch } from 'redux'
import { HttpClient } from '@opallabs/api'
import { loadJsonApiEntities } from '../loadJsonApiEntities'
import removeAssignedUser from '../removeAssignedUser'
import workflowError from '../workflowError'

type AssignmentUpdateParams = {
  attributes?: {
    metadata: {
      title?: string
      is_starred?: boolean
    }
  }
  relationships?: {
    assigned_user: string
  }
  stageId: string
}

type ContextAtrributes = {
  data: {
    id: string
    type: 'assignment'
    attributes?: {
      metadata: {
        title?: string
        is_starred?: boolean
      }
    }
    relationships: Record<string, any>
  }
}

type PatchAssignment = (
  params: AssignmentUpdateParams,
  id: string
) => Promise<AxiosResponse>

type AssignedUserObj = {
  assigned_user: {
    data: {
      id: string
      type: string
    }
  }
}

const getRelationshipObject = (
  params: AssignmentUpdateParams
): AssignedUserObj | Record<string, never> => {
  if (params.relationships) {
    return {
      assigned_user: {
        data: {
          id: params.relationships.assigned_user,
          type: 'user',
        },
      },
    }
  }

  return {}
}

export const patchAssignment: PatchAssignment = (params, id) => {
  const contextAtrributes: ContextAtrributes = {
    data: {
      id,
      type: 'assignment',
      relationships: getRelationshipObject(params),
    },
  }
  if (params.attributes) {
    contextAtrributes.data.attributes = params.attributes
  }

  return HttpClient().patch(
    `${window.location.origin}/workflows/v2/assignments/${id}`,
    contextAtrributes
  )
}

const updateAssignment =
  (params: AssignmentUpdateParams, id: string) =>
  (dispatch: Dispatch): Promise<AxiosResponse> =>
    patchAssignment(params, id)
      .then((response) => {
        const body = response.data
        if (body.data) {
          dispatch(loadJsonApiEntities(body))
        }

        if (response.status === 200) {
          if (
            params.relationships &&
            params.relationships.assigned_user === null
          ) {
            dispatch(removeAssignedUser(id))
          }
        }

        return body.data
      })
      .catch((error) => {
        console.log(error)
        dispatch(
          workflowError({
            context: 'assignment',
            entity: 'moment',
            error,
            requestType: 'update',
            stageId: params.stageId,
            loading: {},
          })
        )
      })

export default updateAssignment
